import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ShowPerformance } from '../../../models/showperformance.model';
import { User } from '../../../models/user.model';
import { AvailabilityReturn } from '../availability-return.model';

@Component({
    selector: 'app-planner-performance-row',
    templateUrl: './planner-performance-row.component.html',
    styleUrls: ['./planner-performance-row.component.scss'],
    standalone: false
})
export class PlannerPerformanceRowComponent {

    @Input() toneelmeesters: User[] = [];
    @Input() availabilities: AvailabilityReturn[] = [];
    @Input() public allowEdit: boolean = false;

    @Output() toneelmeesterScheduleRequested: EventEmitter<User> = new EventEmitter<User>();

    private _performance: ShowPerformance;

    get performance(): ShowPerformance {
        return this._performance;
    }

    @Input() set performance(value: ShowPerformance) {
        if (value && !(value instanceof ShowPerformance)) {
            this._performance = new ShowPerformance().createFromJson(value);
        } else {
            this._performance = value;
        }
    }

    protected emitClick(toneelmeester: User) {
        this.toneelmeesterScheduleRequested.emit(toneelmeester);
    }

    protected getColor(toneelmeester: User, performance: ShowPerformance): string {
        const foundAvailabilities = this.availabilities.filter(a => a.performanceId === performance.id);

        if (foundAvailabilities.length > 0) {
            for (const fa of foundAvailabilities) {
                if (fa.userId === toneelmeester.id) {
                    if (fa.isAvailable) {
                        return 'available'; // User is beschikbaar
                    }
                        return 'danger'; // User is niet beschikbaar

                }
            }

// Als geen enkele availability een match is voor `toneelmeester.id`
            if (this.getFill(toneelmeester, performance) === 'solid') {
                return 'light';
            }
            return 'medium';
        }

// Geen availabilities gevonden voor de performance

        if (this.getFill(toneelmeester, performance) === 'solid') {
            return 'light';
        }

        return 'medium';
    }

    protected getFill(toneelmeester: User, performance: ShowPerformance): 'solid' | 'outline' | 'clear' | 'default' {

        const fillWhenPlanned = 'outline';
        const fillThenNoPlanningForPerformance = 'solid';
        const fillWhenNotPlannedButThereIsPlanning = 'clear';
        const fillWhenNoPlanningButUnavailable = 'solid';

        if (performance.scheduledToneelmeester?.id === toneelmeester.id) {
            return fillWhenPlanned;
        }

        if (performance.scheduledToneelmeester != null) {
            return fillWhenNotPlannedButThereIsPlanning;
        }

        const foundAvailabilities = this.availabilities.filter(a => a.performanceId === performance.id);
        if (foundAvailabilities.length > 0) {
            if (performance.scheduledToneelmeester == null) {

                if (this.isUnavailable(toneelmeester, performance)) {
                    return fillWhenNoPlanningButUnavailable;
                }

                return fillThenNoPlanningForPerformance;
            }
            if (performance.scheduledToneelmeester.id === toneelmeester.id) {
                return fillWhenPlanned;

            }
            return fillWhenNotPlannedButThereIsPlanning;
        }

        // Geen availabilities gevonden voor de performance
        return fillThenNoPlanningForPerformance;
    }

    protected isUnavailable(toneelmeester: User, performance: ShowPerformance): boolean {
        const foundAvailabilities = this.availabilities.filter(a => a.performanceId === performance.id);

        if (foundAvailabilities.length > 0) {
            for (const fa of foundAvailabilities) {
                if (fa.userId === toneelmeester.id) {
                    return !fa.isAvailable;
                }
            }

        }

    }

    protected getToneelmeesterColor(toneelmeester: User): string {
        // Handle null toneelmeester
        if (!toneelmeester) {
            return 'color: #FF0000;';
        }

        // Define a map of names to colors
        const nameColorMap: { [key: string]: string } = {
            jamie: 'background-color: var(--color-jamie);',
            paul: 'background-color: var(--color-paul);',
            peter: 'background-color: var(--color-peter);',
            rens: 'background-color: var(--color-rens);',
            tom: 'background-color: var(--color-tom); color: #FFFFFF;',
            roy: 'background-color: var(--color-roy);'
        };

        // Normalize the first name for case-insensitive comparison
        const normalizedName = toneelmeester.firstName.trim().toLowerCase();

        // Return the corresponding color or the default color
        return nameColorMap[normalizedName] || 'color: #000000;';
    }

    protected getSuggestedToneelmeesterColor(toneelmeester: User): string {
        // Handle null toneelmeester
        if (!toneelmeester) {
            return 'color: #FF0000;';
        }

        // Define a map of names to colors
        const nameColorMap: { [key: string]: string } = {
            jamie: 'border: 6px solid var(--color-jamie);',
            paul: 'border: 6px solid var(--color-paul);',
            peter: 'border: 6px solid var(--color-peter);',
            rens: 'border: 6px solid var(--color-rens);',
            tom: 'border: 6px solid var(--color-tom);',
            roy: 'border: 6px solid var(--color-roy);'
        };

        // Normalize the first name for case-insensitive comparison
        const normalizedName = toneelmeester.firstName.trim().toLowerCase();

        // Return the corresponding color or the default color
        return nameColorMap[normalizedName] || 'color: #000000;';
    }

}
